// removed by extract-text-webpack-plugin
module.exports = {"default":"type__default___2V8cS bg-white boxShadow-smoke--xd--hover boxShadow-smoke","defaultIsFocused":"type__defaultIsFocused___2XZDZ boxShadow-marvel"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-select/Select/style/type.css
// module id = 236
// module chunks = 0 8